import { store } from '../store/store';

const UpdateUser = async (itemId, userData) => {
    const state = store.getState();
    const token = state.user.currentUser.token;
    const API_BASE = state.user.apiBase;
    //console.log(userData);
    try {
        const response = await fetch(`${API_BASE}/users/${itemId}`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(userData)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error updating user:", error);
        throw error;
    }
};

export default UpdateUser;

//api.DELETE("/items/:id",